<template>
  <v-dialog v-model="dialogVisible" 
    persistent max-width="360px"
  >
    <template v-slot:activator="scope">
      <activator-button :scope="scope" />
    </template>

    <v-form @submit.prevent="submitClick">
      <v-card>
        <v-card-text>
          <v-text-field
            outlined dense
            v-model="account_name"
            label="Account Name"
            class="mt-2"
          ></v-text-field>
        </v-card-text>

        <v-divider />

        <v-card-actions class="justify-center">
          <v-btn @click="close">Cancel</v-btn>
          <v-btn color="primary" type="submit">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
  import { ActivatorButton } from '@/components/pages'
  import { mapActions } from 'vuex'

  export default {
    name: 'ContactDialog',

    props: ['account'],

    components: { ActivatorButton },

    data() {
      return {
        dialogVisible: false,

        account_name: '',
      };
    },

    watch: {
      dialogVisible(visible) {
        if( visible ) {
          this.account_name = this.account.account_name
        }
      },
    },

    methods: {
      ...mapActions('accounts', ['updateMe']),
      
      close() {
        this.dialogVisible = false
      },

      async submitClick() {
        const payload = {
          account_name: this.account_name,
        }

        let result = await this.updateMe( payload)
        if( result.ok ) {
          this.close()
        }
      },
    
    },
  };
</script>

<style scoped>
  .v-dialog__content {
    position:  absolute;
  }
</style>